import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    const error = validateField(name, value);

    setErrors(prev => ({
      ...prev,
      [name]: error
    }));
  };

  // form validation 
const [errors, setErrors] = useState({
  name: "",
  email: "",
  phone: "",
  company: "",
  service: ""
});


const validateField = (name, value) => {
  switch (name) {

    case "name":
      if (!value.trim()) return "Name is required";
      if (value.length < 20) return "Name must be at least 20 characters";
      return "";

    case "email":
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value.trim()) return "Email is required";
      if (!emailRegex.test(value)) return "Enter a valid email address";
      return "";

    case "phone":
      const onlyNumbers = /^[0-9]*$/;
      if (!value.trim()) return "Phone number is required";
      if (!onlyNumbers.test(value)) return "Only numbers allowed";
      if (value.length !== 12) return "Phone must be exactly 12 digits";
      return "";

    case "company":
      const textOnly = /^[A-Za-z\s]*$/;
      if (!textOnly.test(value)) return "Only letters allowed (no numbers)";
      if (value.length > 25) return "Company name cannot exceed 25 characters";
      return "";

    case "service":
      if (!value.trim()) return "Service selection is required";
      return "";

    default:
      return "";
  }
};

  // form validation end 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // const response = await fetch('http://localhost:5000/api/contact', {
      const response = await fetch('https://staffindai-backend.onrender.com/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          subject: formData.service,
          message: formData.message
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitStatus({ success: true, message: 'Thank you for your message! We will get back to you soon.' });
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          service: '',
          message: ''
        });
      } else {
        setSubmitStatus({ success: false, message: data.message || 'Something went wrong. Please try again.' });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus({ success: false, message: 'Network error. Please check your connection and try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };



  return (
    <div className="contact-page">
      {/* Hero Section */}
      <div className="contact-hero">
        <div className="container text-center">
          <h1 className="contact-hero-title">
            Contact Us
          </h1>
          {/* <p className="contact-hero-subtitle">
            Ready to transform your business with professional telecalling services? Get in touch with us today.
          </p> */}
        </div>
      </div>

      {/* Contact Cards Section */}
      <div className="contact-cards-section">
        <div className="container">
          <div className="contact-cards-grid">
            <div className="contact-card">
              <div className="contact-card-icon office-icon">
                <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="contact-card-title">Visit Our Office</h3>
              <p className="contact-card-text">4/4A, 1st Floor,</p>
              <p className="contact-card-text"> Kirti Nagar Industrial Area,
                New Delhi - 110015</p>
            </div>

            <div className="contact-card">
              <div className="contact-card-icon phone-icon">
                <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21L6.3 11.043a11.05 11.05 0 005.657 5.657l1.656-3.924a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h3 className="contact-card-title">Call Us</h3>
              <p className="contact-card-text">+91  8076090700</p>
              {/* <p className="contact-card-text">+91 87654 32109</p> */}
            </div>

            <div className="contact-card">
              <div className="contact-card-icon email-icon">
                <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="contact-card-title">Email Us</h3>
              <p className="contact-card-text">info@staffingsupportindia.com</p>
              {/* <p className="contact-card-text">support@admissionshala.com</p> */}
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="contact-section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <div className="contact-form-card">
                <h2 className="contact-form-title">Send us a Message</h2>

                <form onSubmit={handleSubmit} className="contact-form">
                  {submitStatus && (
                    <div className={`form-status ${submitStatus.success ? 'success' : 'error'}`}>
                      {submitStatus.message}
                    </div>
                  )}
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name" className="form-label">
                        Full Name *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Your full name"
                      />
                      {errors.name && <p className="error">{errors.name}</p>}

                    </div>

                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="your.email@example.com"
                      />
                      {errors.email && <p className="error">{errors.email}</p>}

                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="phone" className="form-label">
                       Phone Number with Country Code *
                      </label>
                      <input
                        type="number"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="+1 (555) 123-4567"
                      />
                      {errors.phone && <p className="error">{errors.phone}</p>}

                    </div>

                    <div className="form-group">
                      <label htmlFor="company" className="form-label">
                        Company Name *
                      </label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Your company name"
                      />
                      {errors.company && <p className="error">{errors.company}</p>}

                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="service" className="form-label">
                      Service Interest *
                    </label>
                    <select
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      className="form-input"
                    >
                      <option value="">Select a service</option>
                      <option value="sales_support">Sales and Customer Support</option>
                      <option value="accounting">US / UK Accounting / Bookkeeping</option>
                      <option value="design_creative">Design and Creative</option>
                      <option value="ecommerce">E-commerce and Product Management</option>
                      <option value="marketing">Marketing and Branding</option>

                      <option value="other">Other</option>
                    </select>
                    {errors.service && <p className="error">{errors.service}</p>}

                  </div>

                  <div className="form-group">
                    <label htmlFor="message" className="form-label">
                      Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      required
                      rows={6}
                      value={formData.message}
                      onChange={handleChange}
                      className="form-textarea"
                      placeholder="Tell us about your project requirements..."
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="form-submit-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              </div>
            </div>

            {/* Contact Information */}
            <div className="contact-info-wrapper">
              <div className="contact-info-card">
                <h2 className="contact-info-title">Get in Touch</h2>
                <p className="contact-info-description">
                  We're here to help you succeed. Reach out to us through any of the channels below, and our team will respond promptly to discuss your telecalling needs.
                </p>

                {/* Contact Cards */}
                <div className="contact-info-list">
                  <div className="contact-info-item">
                    <div className="contact-info-icon">
                      <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21L6.3 11.043a11.05 11.05 0 005.657 5.657l1.656-3.924a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <div className="contact-info-content">
                      <h3 className="contact-info-label">Phone</h3>
                      <p className="contact-info-text">+91 8076090700</p>
                      {/* <p className="contact-info-text">+1 (555) 987-6543</p>
                      <p className="contact-info-note">Mon-Fri 9AM-6PM EST</p> */}
                    </div>
                  </div>

                  <div className="contact-info-item">
                    <div className="contact-info-icon">
                      <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div className="contact-info-content">
                      <h3 className="contact-info-label">Email</h3>
                      <p className="contact-info-text">info@staffingsupportindia.com</p>
                      {/* <p className="contact-info-text">sales@telecallpro.com</p> */}
                      <p className="contact-info-note">We respond within 24 hours</p>
                    </div>
                  </div>

                  <div className="contact-info-item">
                    <div className="contact-info-icon">
                      <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                    <div className="contact-info-content">
                      <h3 className="contact-info-label">Office</h3>
                      <p className="contact-info-text">4/4A, 1st Floor,</p>
                      <p className="contact-info-text"> Kirti Nagar Industrial Area,
                        New Delhi - 110015</p>
                      <p className="contact-info-note">Visit by appointment</p>
                    </div>
                  </div>

                  {/* <div className="contact-info-item">
                    <div className="contact-info-icon">
                      <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div className="contact-info-content">
                      <h3 className="contact-info-label">Business Hours</h3>
                      <p className="contact-info-text">Monday - Friday: 9:00 AM - 6:00 PM</p>
                      <p className="contact-info-text">Saturday: 10:00 AM - 4:00 PM</p>
                               </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        {/* <div className="faq-section">
        <div className="faq-container">
          <div className="faq-header">
            <h2 className="faq-title">Frequently Asked Questions</h2>
            <p className="faq-subtitle">
              Quick answers to common questions about our telecalling services.
            </p>
          </div>
          
          <div className="faq-list">
            <div className="faq-item">
              <h3 className="faq-question">How quickly can you start our project?</h3>
              <p className="faq-answer">We can typically begin your telecalling campaign within 3-5 business days after project approval and setup completion.</p>
            </div>
            
            <div className="faq-item">
              <h3 className="faq-question">What industries do you serve?</h3>
              <p className="faq-answer">We serve a wide range of industries including healthcare, finance, real estate, technology, retail, and many more.</p>
            </div>
            
            <div className="faq-item">
              <h3 className="faq-question">Do you provide detailed reporting?</h3>
              <p className="faq-answer">Yes, we provide comprehensive daily, weekly, and monthly reports with detailed analytics and performance metrics.</p>
            </div>
          </div>
        </div>
      </div> */}
      </div>
    </div>
  );
};

export default Contact;